export default __webpack_public_path__ + "static/media/workflowdiagramMOBILE@300x@2x.f031006d.png";